export const PERMISSIONS = {
  EVENTADMIN: "EVENTADMIN",
  PLAYERADMIN: "PLAYERADMIN",
  TEETIMEADMIN: "TEETIMEADMIN"
} as const;

export const ASSIGNABLE_PERMISSIONS = [
  { value: PERMISSIONS.EVENTADMIN, label: 'Event Admin' },
  { value: PERMISSIONS.PLAYERADMIN, label: 'Player Admin' },
  { value: PERMISSIONS.TEETIMEADMIN, label: 'Tee Time Admin' }
];

export const EVENT_FORMAT = {
  SINGLE_COURSE: "SINGLE_COURSE",
  MULTI_COURSE: "MULTI_COURSE",
  MULTI_WEEK_LEAGUE: "MULTI_WEEK_LEAGUE",
  HYBRID_SCRAMBLE: "HYBRID_SCRAMBLE"
} as const;

export type EventFormatType = typeof EVENT_FORMAT[keyof typeof EVENT_FORMAT];

export const BARN_BOOKING_KIND = {
  RESERVATION: "RESERVATION",
  BLACKOUT: "BLACKOUT"
} as const;

export type BarnBookingKindType = typeof BARN_BOOKING_KIND[keyof typeof BARN_BOOKING_KIND];

/*
  Barn hours and booking limits. Times are minutes from midnight in BARN.TIME_ZONE.
  Keep this in sync with api/lib/lambda_handler/models/constants.ts.
*/
export const BARN = {
  TIME_ZONE: "America/Chicago",
  SLOT_MINUTES: 30,
  MIN_DURATION_MINUTES: 30,
  MAX_DURATION_MINUTES: 180,
  DEFAULT_DURATION_MINUTES: 60,
  MAX_DAYS_AHEAD: 56,
  OPEN_MINUTE: 8 * 60,
  CLOSE_MINUTE: 23 * 60
} as const;
